import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { CiTrash, CiCirclePlus } from "react-icons/ci";
import { getPayoutProvider } from "../../config/LiveApi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AddSettlements = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [payoutProviders, setPayoutProviders] = useState([]);
  const [fields, setFields] = useState([{ provider: null, amount: "" }]);

  const  navigate=useNavigate()
  const handleAddField = () => {
    setFields([...fields, { provider: null, amount: "" }]);
  };

  const handleDeleteField = (index) => {
    const updatedFields = fields.filter((_, i) => i !== index);
    setFields(updatedFields);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = fields.map((f, i) =>
      i === index ? { ...f, [field]: value } : f
    );
    setFields(updatedFields);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/view-settlement')
    console.log("Submitted Data:", fields);
  };

  useEffect(() => {
    async function fetchPayoutProvider() {
      try {
        if (!token) throw new Error("Token not available");
        const response = await getPayoutProvider(token);
        const payoutProviders = response.data;
        const formattedOptions = payoutProviders.map((provider) => ({
          value: provider.id,
          label: `${provider.providerName} - ${provider.orgName || "N/A"}`,
        }));

        setPayoutProviders(formattedOptions);
      } catch (error) {
        if (error.response?.status === 401) {
          console.error("Unauthorized - Please log in again.");
        } else {
          console.error("Error fetching payout provider data:", error);
        }
      }
    }
    fetchPayoutProvider();
  }, [token]);

  return (
    <div>
      <div className="out-head" style={{ margin: "20px" }}>
        <h2 className="area-top-title-pay-out">Add settlement</h2>
      </div>
      <form className="provider-form" onSubmit={handleSubmit}>
        {fields.map((field, index) => (
          <div
            key={index}
            className="form-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 0.2fr",
              gap: "20px",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div>
              <p className="label-data">Select Payout Provider</p>
              <ReactSelect
                options={payoutProviders}
                value={field.provider}
                onChange={(selectedOption) =>
                  handleFieldChange(index, "provider", selectedOption)
                }
              />
            </div>
            <div>
              <p className="label-data">Enter settlement Amount</p>
              <input
                type="number"
                name={`settlementamount-${index}`}
                placeholder="Settlement Amount"
                style={{ width: "100%", marginTop: "10px" }}
                value={field.amount}
                onChange={(e) =>
                  handleFieldChange(index, "amount", e.target.value)
                }
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginTop: "40px",
              }}
            >
              <CiCirclePlus
                size={28}
                style={{ color: "green", cursor: "pointer" }}
                onClick={handleAddField}
              />
              {fields.length > 1 && (
                <CiTrash
                  size={28}
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={() => handleDeleteField(index)}
                />
              )}
            </div>
          </div>
        ))}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button type="submit" style={{ margin: "10px" }}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSettlements;
